import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CssBaseline } from "@mui/material";
import VideoFrame from "./VideoFrame";
import ReserveNPricingLinkFrame from "./ReserveNPricingLinkFrame";
import EnrollFrame from "../../elements/EnrollFrame";
import HeroSection from "../../elements/HeroSection";
// import BlogsFrame from "./BlogsFrame";
// import SpecialOfferModal from "../../elements/SpecialOfferModal";
import ReviewFrame from "./ReviewFrame";
import { DiscoverPotentialSection } from "../programPage/DiscoverPotentialSection";
import WhyUsSection from "../nurseryPage/WhyUsSection";
import ReviewsV2CarouselFrame from "../reviewsPage/ReviewsV2CarouselFrame";
import ReviewsJsonLd from "../../utils/ReviewsJsonLd";
import { RawReviews } from "../../utils/buildReviewsSchema";

export interface IconTypographyI {
  isMobile: boolean;
  isSmallMobile: boolean;
  isShortScreen: boolean;
  text: string;
}

const MainPage: React.FC = () => {
  const { t } = useTranslation();
  const reviews = t("ReviewsV2Frame.reviews", { returnObjects: true }) as unknown as RawReviews;

  // const [offerOpen, setOfferOpen] = useState(true);
  // const targetDate = new Date(Date.UTC(2025, 3, 30, 23, 59, 59));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <ReviewsJsonLd
        reviews={reviews}
      />

      <CssBaseline />
      {/* <SpecialOfferModal
        open={offerOpen}
        onClose={() => setOfferOpen(false)}
        targetDate={targetDate}
      /> */}
      <HeroSection
        mainTitle={
          <>
            {t("mainPage.mainTitle1")}
            <br />
            {t("mainPage.mainTitle2")}
          </>
        }
        secondaryTitle={<>{t("mainPage.secondaryTitle")}</>}
        backgroundImageUrl={"/homePage/hero.webp"}
        altImage={t("AltImages.alt_image_home")}
        buttonText={t("mainPage.buttonText")}
        buttonText2={t("mainPage.buttonText2")}
        buttonOnClickPath={"our-program"}
        buttonOnClickPath2={"enroll"}
        isHomePage={true}
      />
      <ReserveNPricingLinkFrame />
      <VideoFrame />
      <WhyUsSection section="home" />
      {/* <BlogsFrame /> */}
      <DiscoverPotentialSection
        title={t("mainPage.DiscoverPotentialSection.title")}
        description={t("mainPage.DiscoverPotentialSection.description")}
        image="/nurseryPage/kinder4.webp"
        buttonText={t("mainPage.DiscoverPotentialSection.buttonText")}
      />
      <ReviewFrame />
      <EnrollFrame />
      <ReviewsV2CarouselFrame />
    </>
  );
};

export default MainPage;
